import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { signupUser, loginUser } from "../../redux/actions/auth";
import PropTypes from "prop-types";

const Login = ({
    signupUser,
    handleSubmit,
    reset,
    dispatch,
    loading,
    isAuthenticated,
    loginUser,
}) => {
    const handleLogin = (data) => {

        loginUser({ email: data.login_email, password: data.login_password });
        dispatch(reset("login_signup_form"));
    };

    const handleSignup = (data) => {
        signupUser(data);
        dispatch(reset("login_signup_form"));
    };
    return (
        <section>
            <div className="site__body">
                <div className="block box_margin">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 d-flex mx-auto d-block">
                                <div className="card flex-grow-1 mb-md-0">
                                    <div className="card-body">
                                        <div className="container">
                                            <div className="col-12 text-center" style={{ backgroundColor: '' }}>
                                                <h3 className="card-title package_summ-title">Order Summary</h3>
                                            </div>
                                            <div className="rounded mx-auto d-block text-center	">
                                                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR-daQf0Rv5APoWxT0hVKIHHy1OxZikqF-li3kUmUNRClS2oF2tInuA7-6xhYYeyRQNHNA&usqp=CAU" className="img-fluid " alt="Responsive image" />
                                            </div>
                                            <div className="col-12 text-center" style={{ marginTop: '20px' }}>
                                                <blockquote className="blockquote text-center">
                                                    <h4 className="mb-0 card-title">Order Confirmed</h4>
                                                    <p className="lead">
                                                        Sit back and relax. Your express package is arriving in 15 minutes
                                                    </p>
                                                </blockquote>
                                            </div>
                                            <div className="col-12 text-center">
                                                <button type="button" className="btn btn-primary" style={{ minWidth: '150px' }}>Continue</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

Login.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
};
const mapStateToProps = ({ auth }) => ({
    loading: auth.loading,
    isAuthenticated: auth.isAuthenticated,
    access: auth.access,
});

export default connect(mapStateToProps, {
    signupUser,
    loginUser,
})(
    reduxForm({
        form: "login_signup_form",
    })(Login)
);
